export interface BarTooltipPositionSettings {
  top?: number;
  left?: number;
  right?: number;
  height: number;
}

export const getBarTooltipPositionSettings = (barId: string, containerId: string): BarTooltipPositionSettings => {
    const wrapperBoundaries = document.querySelector(`#${containerId}`)?.getBoundingClientRect();
    const barBoundaries = document.querySelector(`#${barId}`)?.getBoundingClientRect();

    let tooltipHeight = 40;

    const result: BarTooltipPositionSettings = {
      height: tooltipHeight,
      top: barBoundaries?.top ? barBoundaries.top - 5 - tooltipHeight : undefined
    };
  
    const wrapperWidth = wrapperBoundaries?.width || 0;
    const leftAlignLimit = (wrapperBoundaries?.left || 0) + wrapperWidth * 0.75;
    
    if (barBoundaries?.left && barBoundaries.left < leftAlignLimit) {
      result.left = barBoundaries?.left || 0;
    } else {
      result.right = (wrapperBoundaries?.right || 0) - (barBoundaries?.right || 0);
    }

    return result;
  };